module.exports = __webpack_public_path__ + "img/backHome_02.00d475fb.png";